var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list",
    { attrs: { "three-line": "" } },
    [
      _vm._l(_vm.spedizioni, function (sped, i) {
        return [
          i > 0 ? _c("v-divider", { key: "d_" + i }) : _vm._e(),
          _c("ItemListRigaSpedizione", {
            key: sped.id,
            attrs: { rigaspedizione: sped },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }